import {
  Component,
  OnInit,
  ViewChild,
  Renderer2,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import {
  PoNotificationService,
  PoModalComponent,
  PoModalAction,
  PoUploadComponent,
  PoTableColumn,
  PoDialogService,
  PoModule,
} from "@po-ui/ng-components";

import { Router } from "@angular/router";
import { OrcamentoListService } from "./orcamento-list.service";
import { FormsModule, NgForm } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { Subscription } from "rxjs";
import { QRCodeComponent } from "angularx-qrcode";
import { OrcamentoStatus } from "../orcamento-status.enum";
import { GetnetCreditResponse } from "src/app/shared/types";

@Component({
  selector: "app-orcamento-list",
  templateUrl: "./orcamento-list.component.html",
  styleUrls: ["./orcamento-list.component.css"],
  standalone: false,
})

export class OrcamentoListComponent implements OnInit, OnDestroy {
  elementType = "url";
  value: string;
  data: { id: string };
  tiposColumns: PoTableColumn[];
  vlrpag: number;
  vlrpix: number;
  obs: string;
  documentLabel: string;
  minLength: number;
  nameLabel: string;
  postatus: string;
  orcamentoStatus: OrcamentoStatus;
  docView: string;
  minLengthCEP: number;
  minLengthTel: number;
  getnetToken: string;
  scriptElement: HTMLScriptElement;
  txid: any;
  statusPix: string;
  vendedor: any;
  lojacli: any;
  pedidoOrc: any;
  statusOrc: string;
  valorMinimo: number = 500;
  tipoDoc: string;
  verify: boolean;
  pedidoProtheus: any;
  tabprc: string;
  novoQRCode: boolean = true;
  pago: boolean;
  intervalId: any;
  tiposPag: Array<any> = new Array();
  orcamentoList: Array<any> = new Array();
  orcamento: Array<any> = new Array();
  nome: string;
  orcamentoEfetiva: string;
  bOrcamento: String;
  dialogMethod: string;
  regraIntegracao = true;
  isHideLoading = true;
  restrictions = { allowedExtensions: [".PDF", ".JPG", ".JPEG", ".PNG"] };
  event: string;
  ocData: string;
  ocTransp: string;
  ocEndereco: string;
  ocMotorista: string;
  ocRg: string;
  ocTpVeic: string;
  subTotal: any;
  saldo: any;
  saldosArr: Array<any> = new Array();
  ValorDigit: any;
  ocPlaca: string;
  ocCapacidade: string;
  orcamentoColeta: string;
  emaildanfe: string;
  emailBoleto: string;
  emailColeta: string;
  emailCopiaColeta: string;
  estoqueMessage: Array<any> = new Array();
  chassiList: Array<any> = new Array();
  notaSerieMail: string;
  condPgOptions: Array<any> = new Array();
  emailarea: string;
  pedidoOc: string = "";
  informaPedido: boolean = false;
  obsOc: string;
  CondpgSelect: string;
  chassiColumns: Array<PoTableColumn>;
  cliente: string;
  idCab: string;
  sobrenome: string;
  document: string;
  telent1: string;
  endereco: string;
  resPag: any;
  cep: string;
  numero: string;
  estado: string;
  cidade: string;
  bairro: string;
  mail: string;
  condicaoPagamento: string;
  disabled: string;
  parcelas: any;
  selectParcela: any;
  valorasalvar: any;
  API = environment.API;
  subscription: Subscription;
  filial: string;
  cppix: string = sessionStorage.getItem("cppix");
  cpcred: string = sessionStorage.getItem("cpcred");
  inclusaodesativada: boolean = false;
  lockButton: boolean = false;
  lockBntContinua: boolean = false;

  private getnetListener: (event: MessageEvent) => Promise<void>;

  public loading: boolean = true;
  @ViewChild("getnet") getnet: ElementRef<HTMLInputElement>;
  @ViewChild("StatusPix") StatusPix: ElementRef<HTMLInputElement>;
  @ViewChild("printable") printable: ElementRef<HTMLInputElement>;
  @ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
  @ViewChild("pagamento", { static: true }) pagamento: PoModalComponent;
  @ViewChild("pagOnline", { static: true }) pagOnline: PoModalComponent;
  @ViewChild("addCondPag", { static: true }) addCondPag: PoModalComponent;
  @ViewChild("OrdemColeta", { static: true }) OrdemColeta: PoModalComponent;
  @ViewChild("ModalEstoque", { static: true }) ModalEstoque: PoModalComponent;
  @ViewChild("ModalXMLDanfe", { static: true }) ModalXMLDanfe: PoModalComponent;
  @ViewChild("ModalBoleto", { static: true }) ModalBoleto: PoModalComponent;
  @ViewChild("ModalPrint", { static: true }) ModalPrint: PoModalComponent;
  @ViewChild("ModalChassi", { static: true }) ModalChassi: PoModalComponent;
  @ViewChild("infoOptPag", { static: true }) infoOptPag: PoModalComponent;
  @ViewChild("informa", { static: true }) informa: PoModalComponent;
  @ViewChild("pagCartao", { static: true }) pagCartao: PoModalComponent;
  @ViewChild("pagcomp", { static: true }) pagcomp: PoModalComponent;
  @ViewChild("getnetModal", { static: true }) getnetModal: PoModalComponent;
  @ViewChild("pagPix", { static: true }) pagPix: PoModalComponent;
  @ViewChild("qrCode", { static: true }) qrCode: PoModalComponent;
  @ViewChild("noPIX", { static: true }) noPIX: PoModalComponent;
  @ViewChild("okPIX", { static: true }) okPIX: PoModalComponent;
  i;
  @ViewChild("upload", { static: true }) upload: PoUploadComponent;
  @ViewChild("uploadOn", { static: true }) uploadOn: PoUploadComponent;
  @ViewChild("formOrdemColeta", { static: true }) form: NgForm;

  black() { }

  constructor(
    private orcamentoListService: OrcamentoListService,
    private router: Router,
    private poNotification: PoNotificationService,
    private poAlert: PoDialogService,
    private renderer: Renderer2
  ) {
    // this.getnetListener = this.getnetEvent.bind(this) as (event: MessageEvent) => Promise<void>;
    this.getnetListener = (e: MessageEvent) => this.getnetEvent(e);
  }

  ngOnInit() {
    if (sessionStorage.getItem("Segmento") == "PECAS") {
      this.filial = "0103";
    } else {
      this.filial = "0301";
    }
    this.updateOrcamenoList();
    this.saldo = 0;
    this.loading = false;
    this.dialogMethod = undefined;
    this.emaildanfe = sessionStorage.getItem("user");
    this.condPgOptions = [
      { label: "CARTÃO", value: "CARTÃO" },
      { label: "CARTÃO/PIX", value: "CARTÃO/PIX" },
      { label: "PIX", value: "PIX" },
    ];

    this.orcamentoListService.getValorMinimo().subscribe({
      next: (data) => {
        if (data) {
          const val = parseFloat(data.descricao || data.CONTEUDO || data.valor || data);
          if (!isNaN(val) && val > 0) {
            this.valorMinimo = val;
            sessionStorage.setItem("valorMinimoOrcamento", val.toString());
          }
        }
      },
      error: () => {
        const cached = sessionStorage.getItem("valorMinimoOrcamento");
        if (cached) {
          this.valorMinimo = parseFloat(cached) || 500;
        }
      }
    });

    this.emailBoleto = sessionStorage.getItem("user");
    this.emailColeta = this.emailBoleto;
    this.chassiColumns = this.orcamentoListService.getChassisColumns();
    this.tiposColumns = this.orcamentoListService.getTiposColumns();
  }

  ngOnDestroy(): void {
    this.limparScriptExistente();
  }

  public readonly columns: Array<PoTableColumn> = [
    { property: "numOrcamento", label: "ID Portal", width: "8%" },
    { property: "numPedido", label: "Orçamento", width: "8%" },
    { property: "pedido", label: "Pedido", width: "8%" },
    { property: "nota", label: "Nota Fiscal", width: "8%" },
    {
      property: "emissao",
      label: "Emissão",
      type: "date",
      format: "dd/MM/yyyy",
      width: "8%",
    },

    {
      property: "status",
      label: "Situação",
      type: "label",
      width: "15%",
      labels: [
        {
          value: OrcamentoStatus.EM_ELABORACAO,
          color: "color-11",
          label: "Em elaboração",
          tooltip: "Orçamento NÃO enviado para área comercial",
        },
        {
          value: OrcamentoStatus.EM_ANALISE,
          color: "color-08",
          label: "Em análise",
          tooltip: "Orçamento enviado para área comercial",
        },
        {
          value: OrcamentoStatus.FATURADO,
          color: "color-01",
          label: "Faturado",
          tooltip: "Orçamento faturado sem ajustes",
        },
        {
          value: OrcamentoStatus.FATURADO_COM_AJUSTE,
          color: "color-05",
          label: "Faturado com ajuste",
          tooltip: "Orçamento faturado com ajustes",
        },
        {
          value: OrcamentoStatus.CANCELADO,
          color: "color-07",
          label: "Cancelado",
          tooltip: "Orçamento cancelado",
        },
        {
          value: OrcamentoStatus.CANCELADO_PAGO,
          color: "color-07",
          label: "Cancelado Pago",
          tooltip: "Orçamento pago cancelado",
        },
        {
          value: OrcamentoStatus.AGUARDANDO_COMERCIAL,
          color: "color-09",
          label: "Aguardando Comercial",
          tooltip: "Aguardando tratamento do comercial",
        },
        {
          value: OrcamentoStatus.AGUARDANDO_PAGAMENTO,
          color: "color-04",
          label: "Aguardando Pagamento",
          tooltip: "Aguardando o pagamento do cliente",
        },
        {
          value: OrcamentoStatus.PAGAMENTO_REALIZADO,
          color: "color-01",
          label: "Pagamento Realizado",
          tooltip: "Orçamento Pago Totalmente",
        },
        {
          value: OrcamentoStatus.PAGO_PARCIALMENTE,
          color: "color-05",
          label: "Pago Parcialmente",
          tooltip: "Pago parcialmente",
        },
        {
          value: OrcamentoStatus.EM_EDICAO,
          color: "color-12",
          label: "Em Edição",
          tooltip: "Em Edição",
        },
        {
          value: OrcamentoStatus.LIMITE_NAO_ATINGINDO,
          color: "color-07",
          label: "Lim. Não Atingido",
          tooltip: "Orçamento não atingiu o valor mínimo para faturamento",
        },
      ],
    },
    {
      property: "acoes",
      label: "Ações",
      type: "icon",
      width: "35%",
      icons: [
        {
          action: this.viewOrcamento.bind(this),
          icon: "po-icon po-icon-eye",
          tooltip: "Visualizar/Alterar",
          value: "1",
        },
        {
          action: this.printOrcamento.bind(this),
          icon: "po-icon po-icon-pdf",
          tooltip: "Imprimir",
          value: "2",
        },
        {
          action: this.efetiva.bind(this),
          icon: "po-icon po-icon-finance",
          tooltip: "Efetivar compra",
          color: "color-10",
          value: "3",
        },
        {
          action: this.realizaPag.bind(this),
          icon: "po-icon po-icon-wallet",
          color: "color-02",
          tooltip: "Realizar o Pagamento",
          value: "4",
        },
        {
          action: this.envPagamento.bind(this),
          icon: "po-icon po-icon-finance-secure",
          tooltip: "Comprovante de pagamento",
          value: "5",
          disabled: this.isMotos,
        },
        {
          action: this.Boleto.bind(this),
          icon: "po-icon po-icon-bar-code",
          tooltip: "2ª Via Boleto",
          value: "6",
        },
        {
          action: this.ChassiList.bind(this),
          icon: "po-icon po-icon-document-filled",
          tooltip: "Lista Chassis",
          value: "7",
          disabled: this.isPecas,
        },
        {
          action: this.xmlDanfe.bind(this),
          icon: "po-icon po-icon-xml",
          tooltip: "2o via XML Danfe",
          value: "8",
        },
        {
          action: this.ordemColeta.bind(this),
          icon: "po-icon po-icon-truck",
          tooltip: "Ordem de coleta",
          value: "9",
        },
        {
          action: this.delete.bind(this),
          icon: "po-icon-delete",
          tooltip: "Excluir",
          color: "color-07",
          value: "0",
        }
      ],
    },
  ];

  ordemColeta(orcamento) {
    if (orcamento.status !== OrcamentoStatus.EM_ELABORACAO) {
      this.orcamentoColeta = orcamento.numOrcamento;
      this.pedidoOc = orcamento.pedido;
      if (!this.pedidoOc) {
        this.informaPedido = true;
      } else {
        this.informaPedido = false;
      }
      this.OrdemColeta.open();
    } else {
      this.poAlert.alert({
        title: "Ordem de coleta",
        message: "Favor efetivar compra.",
      });
    }
  }

  limparScriptExistente(): void {
    if (this.scriptElement) {
      window.removeEventListener('message', this.getnetListener as any);
      this.renderer.removeChild(document.body, this.scriptElement);
      this.scriptElement = null;
    }
  }

  async printModalOrcamento() {
    await this.orcamentoListService
      .getItensOrcamento(parseInt(this.orcamentoEfetiva))
      .subscribe(async (Itens) => {
        let itens: Array<any> = new Array();
        for (let index = 0; index < Itens.length; index++) {
          itens.push({
            ITEM: (index + 1).toString(),
            PRODUTO: Itens[index].codProduto,
            QUANTIDADE: Itens[index].quantidade,
            PRECO: Itens[index].prcUnitario,
            TOTAL: Itens[index].prcUnitario * Itens[index].qtdLiberada,
            TPOP: sessionStorage.getItem("tpop"),
          });
        }
        this.ModalPrint.open();
      });
  }

  xmlDanfe(orcamento) {
    if (orcamento.status !== OrcamentoStatus.EM_ELABORACAO) {
      if (orcamento.nota !== "-") {
        this.notaSerieMail = orcamento.nota;
        this.ModalXMLDanfe.open();
      } else {
        this.poAlert.alert({
          title: "Danfe inexistente",
          message: "Orçamento aguardando faturameto",
        });
      }
    } else {
      this.poAlert.alert({
        title: "2o via XML Danfe",
        message: "Favor efetivar compra.",
      });
    }
  }

  openComprovante(opc) {
    if (opc == 1) {
      if (this.saldo - this.vlrpag < 0) {
        this.poNotification.error(
          "Operação negada, saldo ultrapassando o valor total do orçamento."
        );
      } else {
        if (this.vlrpag > 0) {
          this.isHideLoading = false;
          this.orcamentoListService
            .getMailComprovante(sessionStorage.getItem("Segmento"))
            .subscribe((email) => {
              this.emailarea = email.descricao;
              this.pagcomp.open();
              this.isHideLoading = true;
            });
        } else {
          this.poNotification.warning("Informe todos os dados!");
        }
      }
    } else {
      this.pagamento.open();
    }
  }
  openModalInforma() {
    this.vlrpag = 0;
    this.obs = "";
    this.informa.open();
  }

  openpagPix() {
    if (this.novoQRCode) {
      this.pagPix.open();
    } else {
      this.qrCode.open();
    }
  }

  printPage() {
    var divContents = document.getElementById("print").innerHTML;
    var a = window.open("", "", "height=500, width=500");
    a.document.write("<html>");
    a.document.write("<body>");
    a.document.write(divContents);
    a.document.write("</body></html>");
    a.document.close();
    a.print();
  }

  copyQRCode(val: string) {
    navigator.clipboard.writeText(val).then(() => {
      this.poNotification.success("Copiado!");
    });
  }

  async openQRCode() {
    if (this.saldo - this.vlrpix < 0) {
      this.poNotification.error("Operação negada, saldo negativado.");
    } else {
      this.isHideLoading = false;
      let segmento = sessionStorage.getItem("Segmento");

      if (segmento == "PECAS") {
        await this.orcamentoListService
          .geraQRCode(
            "0301",
            this.vlrpix.toString(),
            this.pedidoProtheus,
            this.pedidoOrc,
            segmento
          )
          .subscribe((res) => {
            this.value = res.EMV;
            this.txid = res.TXID;
            this.isHideLoading = true;
          });
      } else {
        await this.orcamentoListService
          .geraQRCode(
            "0301",
            this.vlrpix.toString(),
            this.pedidoProtheus,
            this.pedidoOrc,
            segmento
          )
          .subscribe((res) => {
            this.value = res.EMV;
            this.txid = res.TXID;
            this.isHideLoading = true;
          });
      }
      this.qrCode.open();
    }
  }

  async geraQRCode() {
    let segmento = sessionStorage.getItem("Segmento");

    this.isHideLoading = false;
    if (segmento == "PECAS") {
      await this.orcamentoListService
        .geraQRCode(
          "0301",
          this.vlrpix.toString(),
          this.pedidoProtheus,
          this.pedidoOrc,
          segmento
        )
        .subscribe((res) => {
          this.value = res.EMV;
          this.txid = res.TXID;
          this.isHideLoading = true;
        });
    } else {
      await this.orcamentoListService
        .geraQRCode(
          "0301",
          this.vlrpix.toString(),
          this.pedidoProtheus,
          this.pedidoOrc,
          segmento
        )
        .subscribe((res) => {
          this.value = res.EMV;
          this.txid = res.TXID;
          this.isHideLoading = true;
        });
    }
    this.poNotification.success("QR Code gerado!");
  }

  async validaPIX() {
    const segmento = sessionStorage.getItem("Segmento")

    this.isHideLoading = false;
    if (
      segmento == "PECAS" || segmento == "MOTOS" || segmento == "VEICULOS"
    ) {
      if (this.txid !== "") {
        await this.orcamentoListService
          .consultaPIX(
            "0301",
            sessionStorage.getItem("cgc"),
            sessionStorage.getItem("lojacli"),
            this.vlrpix,
            sessionStorage.getItem("vend1"),
            this.txid,
            "ORCAMENTO: " + this.pedidoOrc + " PEDIDO: " + this.pedidoProtheus
          )
          .subscribe((res) => {
            this.statusPix = res.status.toUpperCase();
            if (this.statusPix == "OK") {
              this.saldosArr = [];
              this.saldosArr.push({
                idCab: parseInt(this.orcamentoEfetiva),
                valorTotal: this.vlrpix,
                tipoPagto: "PIX",
                chavePix: this.value,
                autorizacao: this.txid,
              });
              this.orcamentoListService
                .salvaSaldo(this.saldosArr)
                .subscribe(() => {
                  this.isHideLoading = true;
                  this.okPIX.open();
                  this.novoQRCode = true;
                  this.value = "";
                  this.txid = "";
                  this.vlrpix = 0;
                  this.statusPix = "";
                  this.qrCode.close();
                  this.pagPix.close();
                  this.attTipoPag();
                });
            } else if (this.statusPix == "OKN") {
              this.novoQRCode = false;
              this.qrCode.close();
              this.pagPix.close();
              this.isHideLoading = true;
              this.poNotification.setDefaultDuration(12000);
              this.poNotification.error(
                "Atenção! Ocorreu um erro no processo do seu pagamento. Por favor, entre em contato com a Shineray e envie seu comprovante de pagamento."
              );
            } else if (this.statusPix == "NOK") {
              this.novoQRCode = false;
              this.qrCode.close();
              this.pagPix.close();
              this.isHideLoading = true;
              this.noPIX.open();
            }
          });
      }
    }
  }

  async openpagCartao() {
    this.pagCartao.open();
  }

  Boleto(orcamento) {
    if (orcamento.status !== OrcamentoStatus.EM_ELABORACAO) {
      if (orcamento.nota !== "-") {
        this.notaSerieMail = orcamento.nota;
        this.ModalBoleto.open();
      } else {
        this.poAlert.alert({
          title: "2o Via de Boleto",
          message:
            "Boleto não localizado, favor entrar em contato com a área comercial",
        });
      }
    } else {
      this.poAlert.alert({
        title: "2o Via de Boleto",
        message: "Favor efetivar compra.",
      });
    }
  }

  enviaBoleto() {
    var filialPortal = sessionStorage.getItem("empresa");
    this.isHideLoading = false;
    this.orcamentoListService
      .enviaBoleto(this.emailBoleto, this.notaSerieMail, filialPortal)
      .subscribe((res) => {
        this.poAlert.alert({
          title: "Boleto",
          message: res.STATUS,
        });
        this.isHideLoading = true;
      });
  }

  changeEvent(event) {
    event.data = {
      orcamento: this.orcamentoEfetiva,
      emailarea: this.emailarea,
    };
  }

  async uploadSaldo(event) {
    event.data = {
      orcamento: this.orcamentoEfetiva,
      emailarea: this.emailarea,
    };
    this.saldosArr = [];
    this.saldosArr.push({
      idCab: parseInt(this.orcamentoEfetiva),
      valorTotal: this.vlrpag,
      tipoPagto: "PAGTO JÁ REALIZADO",
    });
    this.orcamentoListService.salvaSaldo(this.saldosArr).subscribe(() => {
      this.attTipoPag();
    });
  }

  async envPagamento(orcamento: any) {
    if (orcamento.flagpg !== "S") {
      if (orcamento.status !== OrcamentoStatus.EM_ELABORACAO) {
        this.orcamentoEfetiva = orcamento.numOrcamento;
        this.isHideLoading = false;
        await this.orcamentoListService
          .getMailComprovante(sessionStorage.getItem("Segmento"))
          .subscribe((email) => {
            this.emailarea = email.descricao;
            this.isHideLoading = true;
          });

        this.pagamento.open();
      } else {
        this.poAlert.alert({
          title: "Comprovante",
          message:
            "Favor efetivar compra para liberar o envio do comprovante de pagamento.",
        });
      }
    } else {
      this.poAlert.alert({
        title: "Comprovante",
        message: "Comprovante enviado anteriormente.",
      });
    }
  }

  closeModalChassi: PoModalAction = {
    action: () => {
      this.ModalChassi.close();
    },
    label: "Fechar",
    danger: true,
  };

  closepagPix: PoModalAction = {
    action: () => {
      this.pagPix.close();
    },
    label: "Fechar",
    danger: true,
  };

  closeQRCODE: PoModalAction = {
    action: async () => {
      this.validaPIX();
    },
    label: "Confirmar",
  };

  verificaStatusPix: PoModalAction = {
    action: async () => {
      this.validaPIX();
    },
    label: "Verificar novamente",
  };

  closeModalInforma: PoModalAction = {
    action: () => {
      this.informa.close();
      this.vlrpag = 0;
      this.uploadOn.clear();
    },
    label: "Cancelar",
  };

  CloseModalpagOnline: PoModalAction = {
    action: () => {
      this.attTipoPag()

      if (
        this.saldo !== 0 &&
        this.saldo < this.subTotal &&
        this.orcamentoStatus !== OrcamentoStatus.PAGO_PARCIALMENTE
      ) {
        console.log(sessionStorage.getItem("empresa"));
        this.orcamentoListService
          .salvaStatusProtheus(
            sessionStorage.getItem("empresa"),
            this.pedidoProtheus.toString(),
            2
          )
          .subscribe((res) => {
            console.log(res);
          });
        let cabOrcamento: Array<any> = new Array();
        cabOrcamento.push({
          id: this.orcamentoEfetiva,
          status: "Pago Parcialmente",
          pedido: this.pedidoOrc,
        });
        this.orcamentoListService
          .SalvaCabOrcamento(cabOrcamento)
          .subscribe(() => {
            this.ngOnInit();
          });
      }
      this.pagOnline.close();
      this.saldo = 0;
      this.tiposPag = [];
    },
    label: "Fechar",
  };

  async ChassiList(orcamento) {
    if (orcamento.status !== OrcamentoStatus.EM_ELABORACAO) {
      if (orcamento.nota !== "-") {
        this.notaSerieMail = orcamento.nota;
        await this.Chassi();
        this.ModalChassi.open();
      } else {
        this.poAlert.alert({
          title: "Listagem de chassis",
          message:
            "Aguardando faturamento, favor entrar em contato com a área comercial",
        });
      }
    }
  }
  Chassi() {
    var filialPortal = sessionStorage.getItem("empresa");
    this.isHideLoading = false;
    this.chassiList = [];
    this.orcamentoListService
      .getChassi(this.notaSerieMail, filialPortal)
      .subscribe((res) => {
        for (let index = 0; index < res.length; index++) {
          this.chassiList.push({
            item: res[index].item,
            codigo: res[index].codigo,
            descricao: res[index].descricao,
            chassi: res[index].chassi,
            cor: res[index].cor,
            cilindrada: res[index].cilindrada,
            modelo: res[index].anoModelo,
            fab: res[index].anoFabrica,
            motor: res[index].motor,
            nuance: res[index].nuance,
          });
        }
        this.isHideLoading = true;
      });
  }

  onClick() {
    this.router.navigate(["orcamento-form"], {});
  }

  isPecas(): boolean {
    return sessionStorage.getItem("Segmento") === "PECAS";
  }

  isMotos(): boolean {
    return sessionStorage.getItem("Segmento") !== "PECAS";
  }

  viewOrcamento(orcamento: any) {
    const id = orcamento.numOrcamento;
    this.router.navigate([`orcamento-view/${id}`], {});
  }

  printOrcamento(orcamento: any) {
    const id = orcamento.numOrcamento;
    this.router.navigate([`orcamento-print/${id}`], {});
  }

  closeOrdemColeta: PoModalAction = {
    action: () => {
      this.OrdemColeta.close();
    },
    label: "Cancelar",
    danger: true,
  };

  confirmOrdemColeta: PoModalAction = {
    action: () => {
      if (!this.form.invalid) {
        this.OrdemColeta.close();
        this.isHideLoading = false;

        this.orcamentoListService
          .getMailOrdemColeta(sessionStorage.getItem("Segmento"))
          .subscribe((email) => {
            this.emailarea = email.descricao;
            this.emailarea += ";" + this.emailColeta;
            this.emailarea += ";" + this.emailCopiaColeta;

            this.orcamentoListService
              .envOrdemColeta(
                this.orcamentoColeta,
                this.pedidoOc,
                this.ocData,
                this.ocTransp,
                this.ocEndereco,
                this.ocMotorista,
                this.ocRg,
                this.ocTpVeic,
                this.ocPlaca,
                this.ocCapacidade,
                this.emailarea,
                this.obsOc
              )
              .subscribe(() => {
                this.isHideLoading = true;
                this.poNotification.success(
                  "Ordem de coleta enviada com sucesso."
                );
              });
          });
      } else {
        this.poNotification.warning("Informe todos os dados!");
      }
    },
    label: "Enviar",
  };

  close: PoModalAction = {
    action: () => {
      this.poModal.close();
    },
    label: "Cancelar",
    danger: true,
  };

  confirmXMLDANFE: PoModalAction = {
    action: () => {
      this.enviaXMLDanfe();
      this.ModalXMLDanfe.close();
    },
    label: "Enviar",
  };

  confirmBoleto: PoModalAction = {
    action: () => {
      this.enviaBoleto();
      this.ModalBoleto.close();
    },
    label: "Enviar",
  };

  confirmEstoque: PoModalAction = {
    action: () => {
      this.ngOnInit();
      this.ModalEstoque.close();
    },
    label: "OK",
  };

  closeXMLDANFE: PoModalAction = {
    action: () => {
      this.ModalXMLDanfe.close();
    },
    label: "Cancelar",
    danger: true,
  };

  closeBoleto: PoModalAction = {
    action: () => {
      this.ModalBoleto.close();
    },
    label: "Cancelar",
    danger: true,
  };

  print: PoModalAction = {
    action: () => {
      window.resizeTo(960, 600);
      window.print();
      this.ModalPrint.close();
    },
    label: "Imprimir",
  };

  closePrint: PoModalAction = {
    action: () => {
      this.ModalPrint.close();
    },
    label: "Cancelar",
    danger: true,
  };

  enviaXMLDanfe() {
    var filialPortal = sessionStorage.getItem("empresa");
    this.isHideLoading = false;
    this.orcamentoListService
      .enviaXMLDanfe(this.emaildanfe, this.notaSerieMail, filialPortal)
      .subscribe((res) => {
        this.poAlert.alert({
          title: "XML & DANFE",
          message: res.STATUS,
        });
        this.isHideLoading = true;
      });
  }

  attTipoPag() {
    this.saldo = this.subTotal;
    this.tiposPag = [];
    this.orcamentoListService
      .getSaldo(parseInt(this.orcamentoEfetiva))
      .subscribe((res) => {
        for (let index = 0; index < res.length; index++) {
          this.tiposPag.push({
            Tipo: res[index].tipoPagto,
            Valor: res[index].valorTotal,
          });
          this.saldo -= res[index].valorTotal;
        }
        this.saldo = this.saldo.toFixed(2);
        if (this.saldo == 0) {
          this.orcamentoListService
            .getMailComprovante(sessionStorage.getItem("Segmento"))
            .subscribe((email) => {
              this.emailarea = email.descricao;
              this.orcamentoListService
                .envMailPagOn(this.orcamentoEfetiva, this.emailarea)
                .subscribe(async () => { });
            });
          let cabOrcamento: Array<any> = new Array();
          cabOrcamento.push({
            id: this.orcamentoEfetiva,
            status: "Pagamento Realizado",
            pedido: this.pedidoOrc,
          });
          this.orcamentoListService
            .SalvaCabOrcamento(cabOrcamento)
            .subscribe(() => {
              this.ngOnInit();
            });
          this.orcamentoListService
            .salvaStatusProtheus(
              sessionStorage.getItem("empresa"),
              this.pedidoProtheus.toString(),
              1
            )
            .subscribe(() => {
              console.log("Totalmente Pago");
            });
          this.poNotification.success(
            "Valor Total atingido pelo Saldo! E-mail enviado para o comercial."
          );
        }
      });
  }

  realizaPag(orcamento: any) {
    if (
      orcamento.status === OrcamentoStatus.AGUARDANDO_PAGAMENTO ||
      orcamento.status === OrcamentoStatus.PAGO_PARCIALMENTE
    ) {
      this.pedidoProtheus = orcamento.pedido;
      this.pedidoOrc = orcamento.numPedido;
      this.orcamentoEfetiva = orcamento.numOrcamento;
      this.orcamentoStatus = orcamento.status;
      this.orcamentoListService
        .getCabOrcamento(orcamento.numOrcamento)
        .subscribe((cabOrcamento) => {
          this.CondpgSelect = cabOrcamento.condPagamento;
          this.subTotal = cabOrcamento.valorTotal;
          this.attTipoPag();
        });
      this.pagOnline.open();
    } else {
      this.poNotification.setDefaultDuration(2500);
      this.poNotification.error(
        "Operação negada, orçamento não está apto para pagamento."
      );
    }
  }

  closeinfoOptPag: PoModalAction = {
    action: () => {
      this.infoOptPag.close();
    },
    label: "Fechar",
  };

  closeGetNet: PoModalAction = {
    action: () => {
      this.limparScriptExistente();
      this.lockBntContinua = false
      this.getnetModal.close();
    },
    label: "Cancelar",
    danger: true,
  };

  closePIX: PoModalAction = {
    action: () => {
      this.noPIX.close();
      this.okPIX.close();
      this.pagPix.close();
    },
    label: "Fechar",
  };

  compModalClose: PoModalAction = {
    action: () => {
      this.uploadOn.clear();
      this.pagcomp.close();
      this.informa.close();
      this.updateOrcamenoList();
    },
    label: "Fechar",
    danger: true,
  };

  comprovanteModalClose: PoModalAction = {
    action: () => {
      this.upload.clear();
      this.pagamento.close();
      this.updateOrcamenoList();
    },
    label: "Fechar",
    danger: true,
  };

  compOnlineModalClose: PoModalAction = {
    action: () => {
      this.upload.clear();
      this.pagamento.close();
    },
    label: "Fechar",
  };

  closePagCartao: PoModalAction = {
    action: () => {
      this.pagCartao.close();
      this.lockButton = false
      this.lockBntContinua = false
    },
    label: "Cancelar",
  };

  confirm: PoModalAction = {
    action: () => {
      this.estoqueMessage = [];
      var filialPortal = sessionStorage.getItem("empresa");

      this.isHideLoading = false;
      this.poModal.close();
      this.orcamentoListService
        .getCabOrcamento(parseInt(this.orcamentoEfetiva))
        .subscribe(async (CabOrcamento) => {
          // const dataB = new Date(CabOrcamento.emissao);
          const data = this.formatDateOnlyUTC(CabOrcamento.emissao);

          await this.orcamentoListService
            .getItensOrcamento(parseInt(this.orcamentoEfetiva))
            .subscribe(async (Itens) => {
              let itens: Array<any> = new Array();
              for (let index = 0; index < Itens.length; index++) {
                itens.push({
                  ITEM: (index + 1).toString(),
                  PRODUTO: Itens[index].codProduto,
                  QUANTIDADE: Itens[index].quantidade,
                  PRECO: Itens[index].prcUnitario,
                  TOTAL: Itens[index].prcUnitario * Itens[index].qtdLiberada,
                  TPOP: sessionStorage.getItem("tpop"),
                });
              }

              if (sessionStorage.getItem("Segmento") == "PECAS") {
                let Produtos: Array<any> = new Array();
                for (let index = 0; index < Itens.length; index++) {
                  Produtos.push({
                    Codigo: Itens[index].codProduto,
                    Quantidade: Itens[index].quantidade,
                  });
                }
                this.orcamentoListService
                  .getEstoqueP(Produtos)
                  .subscribe((Itens) => {
                    for (
                      let index = 0;
                      index < Itens.SALDOPRODUTOS.length;
                      index++
                    ) {
                      if (!Itens.SALDOPRODUTOS[index].ESTOQUE) {
                        this.estoqueMessage.push({
                          ITEM: index + 1,
                          CODIGO: Itens.SALDOPRODUTOS[index].CODIGO,
                          PRODUTO: Itens.SALDOPRODUTOS[index].PRODUTO,
                        });
                      }
                    }
                    this.isHideLoading = true;
                    if (this.estoqueMessage.length > 0) {
                      this.ModalEstoque.open();
                    }
                  });
              }
              if (
                sessionStorage
                  .getItem("cpcred")
                  .indexOf(CabOrcamento.condPagamento.toString()) != -1
              ) {
                this.tabprc = sessionStorage.getItem("tabesp");
              } else {
                this.tabprc = sessionStorage.getItem("tabprc");
              }
              const inputStatus = (CabOrcamento.status === OrcamentoStatus.LIMITE_NAO_ATINGINDO && (CabOrcamento.valorTotal >= this.valorMinimo || sessionStorage.getItem("Segmento") !== 'PECAS'))
                ? OrcamentoStatus.EM_ELABORACAO
                : CabOrcamento.status;

              this.orcamentoListService
                .vendaOrcamento({
                  PEDIDO: {
                    EMPRESA: "01",
                    FILIAL: filialPortal,
                    NUM_PEDIDO: parseInt(this.orcamentoEfetiva),
                    CGCCPF: CabOrcamento.cgc,
                    OPERACAO: "I",
                    EMISSAO: data,
                    COND_PAGTO: CabOrcamento.condPagamento,
                    OBS: CabOrcamento.observacao,
                    USER: sessionStorage.getItem("codeuser"),
                    DESPESA: Number(CabOrcamento.despesas),
                    STATUS: inputStatus,
                    SEGMTO: sessionStorage.getItem("Segmento"),
                    ITENS: itens,
                    TABELA: this.tabprc,
                    TOTAL_NF: CabOrcamento.valorTotal,
                  },
                })
                .subscribe(
                  (Orcamento) => {
                    if (Orcamento.Retorno == "400") {
                      this.poNotification.error(
                        "Atenção! Empresa não identificada. Logue outra vez e tente novamente."
                      );
                      this.isHideLoading = true;
                    } else {
                      let cabOrcamento: Array<any> = new Array();

                      cabOrcamento.push({
                        id: CabOrcamento.id,
                        status: OrcamentoStatus.AGUARDANDO_COMERCIAL,
                        pedido: Orcamento[0].Pedido,
                        numPedido: Orcamento[0].numPedido
                      });

                      this.orcamentoListService
                        .SalvaCabOrcamento(cabOrcamento)
                        .subscribe(() => {
                          this.isHideLoading = true;

                          //Saulo Maciel - Retira o envio do email para o comercial apos o processo de inclusao, a partir desse ponto a responsabilidade de envio do email é do Protheus
                          // this.orcamentoListService
                          //   .getMailComercial(
                          //     sessionStorage.getItem("Segmento")
                          //   )
                          //   .subscribe((email) => {
                          //     this.emailarea = email.descricao;

                          //     this.orcamentoListService
                          //       .envMailOrcamento(
                          //         this.orcamentoEfetiva,
                          //         this.emailarea
                          //       )
                          //       .subscribe(async () => { });
                          //   });
                          this.ngOnInit();
                        });

                      this.poNotification.setDefaultDuration(3500);
                      this.poNotification.success(Orcamento[0].msg);
                    }
                  },
                  (err) => {
                    let cabOrcamento: Array<any> = new Array();

                    cabOrcamento.push({
                      id: CabOrcamento.id,
                      // status: err.error.errorMessage,
                    });

                    this.orcamentoListService
                      .SalvaCabOrcamento(cabOrcamento)
                      .subscribe(() => {
                        this.isHideLoading = true;
                      });
                    this.poNotification.setDefaultDuration(3500);
                    this.poNotification.error(err.error.errorMessage);

                    this.ngOnInit();
                  }
                );
            });
        });
    },
    label: "Enviar",
  };

  pad2(n: number): string {
    return String(n).padStart(2, '0');
  }

  formatDateOnlyUTC(dateString: string): string {
    const [datePart] = dateString.split('T');
    const [yyyy, mm, dd] = datePart.split('-');

    return `${yyyy}${mm}${dd}`;
  }

  updateOrcamenoList(): void {
    this.orcamentoListService
      .getOrcamentoList(
        "",
        sessionStorage.getItem("Segmento"),
        sessionStorage.getItem("cgc")
      )
      .subscribe((response) => {
        this.orcamentoList = [];
        this.orcamento = [];
        for (let index = 0; index < response.length; index++) {
          var id = response[index].id;
          this.orcamento.push({
            numOrcamento:
              id.toString().length > 4 ? id : ("0000" + id).slice(-4),
            numPedido: response[index].numPedido,
            nota: response[index].notaFiscal,
            cgc: response[index].cgc,
            emissao: response[index].emissao.replace("Z", ""),
            status: response[index].status,
            acoes: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            flagpg: response[index].flagpg,
            pedido: response[index].pedido,
          });
        }
        this.orcamentoList = this.orcamento;
      });
  }

  async pagar() {
    this.condicaoPagamento = "";
    this.lockBntContinua = true;
    this.lockButton = false
    this.attTipoPag()

    if (this.saldo - this.valorasalvar < 0) {
      this.poNotification.error(
        "Saldo ultrapassado, por favor, reavalie o valor."
      );
      this.lockBntContinua = false;
    } else {
      if (
        sessionStorage
          .getItem("cpcred")
          .indexOf(this.CondpgSelect.toString()) != -1
      ) {
        this.condicaoPagamento = "CARTÃO CRÉDITO";
        this.disabled = '["boleto", "pix", "qr-code", "debito"]';
      } else {
        this.condicaoPagamento = "CARTÃO DÉBITO";
        this.disabled = '["boleto", "pix", "qr-code", "credito"]';
      }
      await this.orcamentoListService
        .efetuaPagamento()
        .subscribe(async (res) => {
          this.resPag = JSON.parse(res);
          this.getnetToken =
            this.resPag.token_type + " " + this.resPag.access_token;
          if (this.document.length > 11) {
            this.tipoDoc = "CNPJ";
          } else {
            this.tipoDoc = "CPF";
          }
          this.verify = true;
          this.limparScriptExistente();
          this.scriptElement = this.orcamentoListService.createJsScript(
            this.renderer,
            this.getnetToken,
            this.valorasalvar.toFixed(2),
            this.filial + this.pedidoProtheus.toString(),
            this.nome,
            this.sobrenome,
            this.tipoDoc,
            this.document,
            this.mail,
            this.telent1,
            this.endereco,
            this.numero,
            this.bairro,
            this.cidade,
            this.estado,
            this.cep,
            this.disabled
          );

          this.scriptElement.addEventListener("load", async () => {
            window.addEventListener('message', this.getnetListener as any);
          });
          this.openGetNet();
        });
    }
  }

  Travar() {
    this.lockButton = true
  }

  async getnetEvent(event: MessageEvent) {
    this.lockButton = true;

    const raw = event?.data ?? '';

    let payload: GetnetCreditResponse | any = raw;
    if (typeof raw === 'string') {
      try { payload = JSON.parse(raw); } catch { /* mantém string */ }
    }

    // Definição do status ANTES do switch (com let e atribuição)
    let status: string;
    if (payload && typeof payload === 'object' && 'status' in payload) {
      status = payload.status;
    } else if (raw && typeof raw === 'object' && 'status' in (raw as any)) {
      status = (raw as any).status;
    } else {
      status = String(raw); // cobre casos como 'close'
    }

    switch (status) {
      case 'APPROVED':
      case 'success': // compatível com seu fluxo legado
        if (this.verify) {
          this.isHideLoading = false;

          const saldo = [{
            idCab: this.orcamentoEfetiva,
            valorTotal: this.valorasalvar,
            tipoPagto: this.condicaoPagamento,

            // Campos úteis do retorno:
            bandeira: payload?.credit?.brand,
            nsu: payload?.credit?.terminal_nsu,
            transacao: payload?.credit?.transaction_id,
            adquirente: payload?.credit?.acquirer
          }];

          this.orcamentoListService.salvaSaldo(saldo).subscribe(() => {
            this.attTipoPag();
            this.getnetModal.close();
            this.pagCartao.close();
            this.infoOptPag.close();
            this.valorasalvar = null;
            this.limparScriptExistente();
            this.isHideLoading = true;
          });
        }
        this.verify = false;
        break;

      case 'close':
        this.limparScriptExistente();
        this.valorasalvar = null;
        this.getnetModal.close();
        this.lockButton = false;
        this.lockBntContinua = false;
        break;

      default:
        // Trate outros status (ex.: 'DENIED', 'CANCELED', etc.)
        this.lockButton = false;
        this.lockBntContinua = false;
        break;
    }
  }

  openGetNet() {
    this.getnetModal.open();
  }

  buscaOrcamento(): void {
    this.orcamentoListService
      .getOrcamentoList(
        this.bOrcamento,
        sessionStorage.getItem("Segmento"),
        sessionStorage.getItem("cgc")
      )
      .subscribe((response) => {
        this.orcamentoList = [];
        this.orcamento = [];
        var id = response.id;
        this.orcamento.push({
          numOrcamento: id.toString().length > 4 ? id : ("0000" + id).slice(-4),
          numPedido: response.numPedido,
          cgc: response.cgc,
          emissao: response.emissao.replace("Z", ""),
          status: response.status,
        });

        this.orcamentoList = this.orcamento;
      });
  }

  delete(orcamento: any) {
    let cabOrcamento: Array<any> = new Array();
    if (orcamento.status === OrcamentoStatus.EM_ELABORACAO || orcamento.status === OrcamentoStatus.LIMITE_NAO_ATINGINDO) {
      if (confirm("Deseja excluir o orçamento?")) {
        cabOrcamento.push({
          id: parseInt(orcamento.numOrcamento),
          status: "Excluido",
        });

        this.orcamentoListService
          .SalvaCabOrcamento(cabOrcamento)
          .subscribe(() => {
            this.poNotification.setDefaultDuration(1500);
            this.poNotification.success("Deletado com sucesso!");
            this.ngOnInit();
          });
      }
    } else {
      this.poNotification.setDefaultDuration(2500);
      this.poNotification.error(
        "Operação negada, orçamento efetivado anteriormente"
      );
    }
  }

  addCondicaoPag() {
    this.addCondPag.open();
  }

  OptPagamentos() {
    if (this.saldo < 0) {
      this.poNotification.error(
        "Operação negada, saldo já atingiu valor total do orçamento."
      );
    } else {
      this.attTipoPag()
      this.infoOptPag.open();
    }
  }

  efetiva(orcamento: any) {
    if (orcamento.status === OrcamentoStatus.LIMITE_NAO_ATINGINDO) {
      const vlrFormatted = this.valorMinimo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.poNotification.setDefaultDuration(2500);
      this.poNotification.error(
        `Operação negada, orçamento com valor total inferior a R$ ${vlrFormatted}.`
      );
      return;
    }

    if (
      orcamento.status === OrcamentoStatus.EM_ELABORACAO ||
      orcamento.status === OrcamentoStatus.INTERNAL_ERROR ||
      orcamento.status === OrcamentoStatus.EM_EDICAO ||
      orcamento.status === ""
    ) {
      this.orcamentoEfetiva = orcamento.numOrcamento;
      this.poModal.open();
    } else {
      this.poNotification.setDefaultDuration(2500);
      this.poNotification.error(
        "Operação negada, orçamento efetivado anteriormente"
      );
    }
  }

  mascaraCEP() {
    this.minLengthCEP = 8;
    this.minLengthTel = 11;
  }
}
